import React from 'react';
import {
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  FormHelperText,
} from '@mui/material';

const RadioGroupWrapper = ({ field, value, onChange, error }) => {
  return (
    <FormControl component="fieldset" error={!!error} margin="normal">
      <FormLabel component="legend">{field.label}</FormLabel>
      <RadioGroup
        name={field.name}
        value={value}
        onChange={(e) => onChange(field.name, e.target.value)}
        row
      >
        {field.options.map((option) => (
          <FormControlLabel
            key={option.value}
            value={option.value}
            control={<Radio />}
            label={option.label}
          />
        ))}
      </RadioGroup>
      {error && <FormHelperText>{error}</FormHelperText>}
    </FormControl>
  );
};

export default RadioGroupWrapper;
